<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-tabs default-active-key="trainSetting">
        <a-tab-pane key="trainSetting" tab="角色设置">
          <a-form :form="form1">
            <a-row class="items">
              <a-col :span="24">
                <a-form-item label="个人用户角色" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-select
                    placeholder="请选择个人用户角色"
                    v-decorator="[
                'studentRoleId',
                  {rules: [{ required: true, message: '请选择个人用户角色!' }], initialValue: info.trainSetting?info.trainSetting.studentRoleId:''}
                ]"
                  >
                    <a-select-option
                      :value="info.id"
                      v-for="(info, index) in roleList"
                      :key="index"
                    >{{info.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="企业用户角色" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-select
                    placeholder="请选择企业用户角色"
                    v-decorator="[
                'enterpriseRoleId',
                  {rules: [{ required: true, message: '请选择企业用户角色!' }], initialValue: info.trainSetting?info.trainSetting.enterpriseRoleId:''}
                ]"
                  >
                    <a-select-option
                      :value="info.id"
                      v-for="(info, index) in roleList"
                      :key="index"
                    >{{info.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="教师用户角色" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-select
                    placeholder="请选择教师用户角色"
                    v-decorator="[
                'teacherRoleId',
                  {rules: [{ required: true, message: '请选择教师用户角色!' }], initialValue: info.trainSetting?info.trainSetting.teacherRoleId:''}
                ]"
                  >
                    <a-select-option
                      :value="info.id"
                      v-for="(info, index) in roleList"
                      :key="index"
                    >{{info.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="统计管理员角色" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-select
                          placeholder="请选择统计管理员角色"
                          v-decorator="[
                'statisticsPermissionUserRoleId',
                  {rules: [{ required: true, message: '请选择统计管理员角色!' }], initialValue: info.trainSetting?info.trainSetting.statisticsPermissionUserRoleId:''}
                ]"
                  >
                    <a-select-option
                            :value="info.id"
                            v-for="(info, index) in roleList"
                            :key="index"
                    >{{info.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
              <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="trainSettingSubmit" />
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="courseSetting" tab="课程设置">
          <a-form :form="form2">
            <a-row class="items">
              <a-col :span="24">
                <a-form-item label="培训日期" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-range-picker
                    v-decorator="['time', {initialValue: [moment(info.courseSetting.startTime, 'YYYY-MM-DD'), moment(info.courseSetting.endTime, 'YYYY-MM-DD')]}]"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                    @change="onRangeChange"
                  ></a-range-picker>
                </a-form-item>
                <a-form-item label="试看时长" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-input
                    placeholder="请输入试看时长"
                    v-decorator="[
                  'duration',
                  {rules: [{required: true, validator:  durationValid}],initialValue:info.courseSetting.duration}]"
                  ></a-input>
                </a-form-item>
                <a-form-item label="第三方课程进度回调地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-input
                    placeholder="请输入课程进度回调地址"
                    v-decorator="[
                  'progressCbUrl',
                  {rules: [{required: true}],initialValue:info.courseSetting.progressCbUrl}]"
                  ></a-input>
                </a-form-item>
                <a-form-item label="IOS是否可购买" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-radio-group v-model="info.courseSetting.iosBuy">
                    <a-radio value="1">是</a-radio>
                    <a-radio value="0">否</a-radio>
                  </a-radio-group>
        </a-form-item>
                <a-form-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <a-upload
                          :action="$api.file.uploadFile"
                          listType="picture-card"
                          :fileList="fileList"
                          @preview="handlePreview"
                          @change="handleChange"
                  >
                    <div v-if="fileList.length < 1">
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                    <img alt="example" style="width: 100%" :src="previewImage"/>
                  </a-modal>
                  建议尺寸:260像素*160像素
                </a-form-item>
        </a-col>
        </a-row>
        <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
          <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="courseSettingSubmit" />
        </a-form-item>
        </a-form>
        </a-tab-pane>
        <a-tab-pane key="certificateSetting" tab="证书设置">
          <a-form :form="form3">
            <a-row class="items">
              <a-col :span="24">
                <a-form-item label="是否自动生成证书" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-radio-group v-model="info.certificateSetting.autoGrant">
                    <a-radio value="0">否</a-radio>
                    <a-radio value="1">是</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item
                  label="是否自动审核证书申请"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 10 }"
                >
                  <a-radio-group v-model="info.certificateSetting.autoAudit">
                    <a-radio value="0">否</a-radio>
                    <a-radio value="1">是</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
              <pxkeji-btn
                name="保存"
                type="primary"
                htmlType="submit"
                @click="certificateSettingSubmit"
              />
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="liveSetting" tab="直播设置">
          <a-form :form="form4">
            <a-row class="items">
              <a-col :span="24">
                <a-form-item label="续播间隔时间配置" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-input
                          placeholder="请输入续播间隔时间"
                          v-decorator="[
                  'intervalTime',
                  {rules: [{required: true, validator:  durationValid}],initialValue:info.liveSetting.intervalTime}]"
                  ></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
              <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="liveSettingSubmit" />
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="orderSetting" tab="订单设置">
          <a-form :form="form5">
            <a-row class="items">
              <a-col :span="24">
                <a-form-item label="退款天数设置" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-input
                          placeholder="退款天数设置"
                          v-decorator="[
                  'returnLimitDays',
                  {rules: [{required: true, validator:  durationValid}],initialValue:info.orderSetting.returnLimitDays}]"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="发票申请天数设置" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                  <a-input
                          placeholder="发票申请天数设置"
                          v-decorator="[
                  'invoiceLimitDays',
                  {rules: [{required: true, validator:  durationValid}],initialValue:info.orderSetting.invoiceLimitDays}]"
                  ></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
              <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="orderSettingSubmit" />
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="socrePushSetting" tab="成绩推送">
            <a-form :form="form6">
                <a-row class="items">
                    <a-col :span="24">
                        <a-form-item label="是否推送" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                            <a-radio-group v-model="info.socrePushSetting.isPush">
                                <a-radio value="0">否</a-radio>
                                <a-radio value="1">是</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24" v-if="info.socrePushSetting.isPush==1">
                        <a-form-item label="考试成绩推送地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="考试成绩推送地址"
                                    v-decorator="[ 'examinationUrl',{rules: [{required: true, message: '请输入考试成绩推送地址!'}],initialValue:info.socrePushSetting.examinationUrl}]"
                            ></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24" v-if="info.socrePushSetting.isPush==1">
                        <a-form-item label="学习成绩推送地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="学习成绩推送地址"
                                    v-decorator="[ 'studyUrl',{rules: [{required: true, message: '请输入学习成绩推送地址!'}],initialValue:info.socrePushSetting.studyUrl}]"
                            ></a-input>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
                    <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="socrePushSettingSubmit" />
                </a-form-item>
            </a-form>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
var that;
import moment from "moment"
export default {
  name: "parameter",
  data() {
    return {
      durationValid: (rule, val, callback) => {
        if (!/^([1-9][0-9]*)$/.test(val)) {
          callback("请输入正确的时长");
        } else {
          callback();
        }
        callback();
      },
      moment,
      form1: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      form4: this.$form.createForm(this),
      form5: this.$form.createForm(this),
      form6: this.$form.createForm(this), //2021 11 03
      previewVisible: false,
      previewImage: "",
      fileList: [],
      info: {
        trainSetting: {
          studentRoleId: "",
          teacherRoleId: "",
          trainSetting: "",
        },
        courseSetting: {
          startTime: "",
          endTime: "",
          duration: "",
          progressCbUrl:"",
          picUrl:"",
        },
        certificateSetting: {
          autoGrant: "0",
          autoAudit: "0",
        },
        liveSetting:{
          intervalTime : "0"
        },
        // 2021 11 03 start
        socrePushSetting:{
            isPush : "0",
            examinationUrl:"",
            studyUrl:"",
        },
        // 2021 11 03 end
        orderSetting:{
          returnLimitDays : "7",
          invoiceLimitDays : 7
        }
      },
      isloading: false,
      roleList: [],
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.getRoleForFront();
      this.getSystemSetting();
      this.getPushSettingSubmit(); //2021 11 03
    });
  },
  methods: {
    // 2021 11 03 start
    socrePushSettingSubmit() {
        this.isloading = true;
        that.form6.validateFields((err, values) => {
            if (!err) {
                this.info.socrePushSetting = {
                    isPush: this.info.socrePushSetting.isPush,
                    examinationUrl: values.examinationUrl,
                    studyUrl: values.studyUrl
                };
                this.$api.systemSetting
                    .setSocrePushSetting(this.info.socrePushSetting)
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.$message.success(res.errorMsg);
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            }
        });
    },
    getPushSettingSubmit(){
        this.isloading = true;
        this.$api.systemSetting
        .getSettingBykey({key:'socrePushSetting'})
        .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
                this.info.socrePushSetting.isPush=res.data.isPush?res.data.isPush:'0';
                this.info.socrePushSetting.examinationUrl=res.data.examinationUrl?res.data.examinationUrl:'';
                this.info.socrePushSetting.studyUrl=res.data.studyUrl?res.data.studyUrl:'';
                this.info.socrePushSetting= {
                    isPush: values.isPush,
                    examinationUrl: values.examinationUrl,
                    studyUrl: values.studyUrl
                };
            } else {
                this.$message.error(res.errorMsg);
            }
        })
        .catch(() => {
            this.isloading = false;
        });
    },
    // 2021 11 03 end
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
    onRangeChange(value, dateString) {
      this.info.courseSetting.startTime = dateString[0];
      this.info.courseSetting.endTime = dateString[1];
    },
    getRoleForFront() {
      this.$api.role
        .getRoleForFront()
        .then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.roleList = res.data;
          }
        })
        .catch(() => {
          this.error();
        });
    },
    getSystemSetting() {
      this.isloading = true;
      this.$api.systemSetting
        .getSystemSetting()
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if (res.data.trainSetting) {
              this.info.trainSetting = res.data.trainSetting;
            }
            if (res.data.courseSetting) {
              this.info.courseSetting = res.data.courseSetting;
              this.info.courseSetting.iosBuy = String(
                      res.data.courseSetting.iosBuy
              );
              if (res.data.courseSetting.picUrl) {
                var pics = res.data.courseSetting.picUrl.split(",");
                for (var i = 0; i < pics.length; i++) {
                  this.fileList.push({
                    uid: i,
                    name: "课程图片" + (i + 1) + ".png",
                    status: "done",
                    url: pics[i],
                  });
                }
              }
            }
            if (res.data.certificateSetting) {
              this.info.certificateSetting.autoGrant = String(
                res.data.certificateSetting.autoGrant
              );
              this.info.certificateSetting.autoAudit = String(
                res.data.certificateSetting.autoAudit
              );
            }
            if(res.data.liveSetting){
              this.info.liveSetting=res.data.liveSetting
            }
            if(res.data.orderSetting){
              this.info.orderSetting=res.data.orderSetting
            }
            console.log(this.info);
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /**提交 */
    trainSettingSubmit() {
      this.isloading = true;
      that.form1.validateFields((err, values) => {
        if (!err) {
          this.info.trainSetting = {
            studentRoleId: values.studentRoleId,
            enterpriseRoleId: values.enterpriseRoleId,
            teacherRoleId: values.teacherRoleId,
            statisticsPermissionUserRoleId: values.statisticsPermissionUserRoleId,
          };
          this.$api.systemSetting
            .setTrainSetting(this.info.trainSetting)
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    /**提交 */
    courseSettingSubmit() {
      this.isloading = true;
      that.form2.validateFields((err, values) => {
        if (!err) {
          this.info.courseSetting.duration = values.duration;
          this.info.courseSetting.progressCbUrl = values.progressCbUrl;
          this.picArr = [];
          for (var i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].url) {
              this.picArr.push(this.fileList[i].url);
            } else if (this.fileList[i].response.data.path) {
              this.picArr.push(this.fileList[i].response.data.path);
            }
          }
          this.info.courseSetting.picUrl= this.picArr[0];
          this.$api.systemSetting
            .setCourseSetting(this.info.courseSetting)
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    certificateSettingSubmit() {
      this.isloading = true;
      that.form3.validateFields((err, values) => {
        if (!err) {
          this.$api.systemSetting
            .setCertificateSetting(this.info.certificateSetting)
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      this.fileList = info.fileList;
    },
    /**提交 */
    liveSettingSubmit() {
      this.isloading = true;
      that.form4.validateFields((err, values) => {
        if (!err) {
          this.info.liveSetting.intervalTime = values.intervalTime;
          this.$api.systemSetting
                  .setLiveSetting(this.info.liveSetting)
                  .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                      this.$message.success(res.errorMsg);
                    } else {
                      this.$message.error(res.errorMsg);
                    }
                  })
                  .catch(() => {
                    this.isloading = false;
                  });
        }
      });
    },
    /**提交 */
    orderSettingSubmit() {
      this.isloading = true;
      that.form5.validateFields((err, values) => {
        if (!err) {
          this.info.orderSetting.returnLimitDays = values.returnLimitDays;
          this.info.orderSetting.invoiceLimitDays = values.invoiceLimitDays;
          this.$api.systemSetting
                  .setOrderSetting(this.info.orderSetting)
                  .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                      this.$message.success(res.errorMsg);
                    } else {
                      this.$message.error(res.errorMsg);
                    }
                  })
                  .catch(() => {
                    this.isloading = false;
                  });
        }
      });
    },
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
.items {
  /* margin: 15px 0; */
  border-bottom: 1px #e8e8e8 solid;
  padding: 20px 0;
  color: rgba(0, 0, 0, 0.85);
}
</style>

